import React from 'react'
import { Outlet, Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ShoppingCartIcon } from '@heroicons/react/24/outline'
import LanguageSwitcher from './LanguageSwitcher'
import { useAuth } from '../hooks/useAuth'
import { useCart } from '../hooks/useCart'

function PublicLayout() {
  const { t } = useTranslation()
  const { user } = useAuth()
  const { itemCount } = useCart()

  const isBuyer = user?.role === 'FAMILY' || user?.role === 'ADMIN'
  const dashboardPath = user?.role === 'VENDOR' ? '/vendor-dashboard' : '/dashboard'

  return (
    <div className="min-h-screen bg-neutral-50">
      {/* Top navigation bar */}
      <div className="sticky top-0 z-10 bg-white border-b border-neutral-200">
        <div className="flex items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
          <div className="flex items-center">
            <Link to="/" className="flex items-center">
              <h1 className="text-xl font-semibold text-neutral-900">
                {t('app.name')}
              </h1>
            </Link>
          </div>

          <div className="flex items-center space-x-4">
            <Link
              to="/products"
              className="text-sm text-neutral-600 hover:text-neutral-900"
            >
              {t('nav.products')}
            </Link>

            {user ? (
              <>
                {isBuyer && (
                  <Link
                    to="/cart"
                    className="relative p-2 -my-2 rounded-md text-neutral-600 hover:text-neutral-900 hover:bg-neutral-100"
                    aria-label={t('nav.cart')}
                    title={t('nav.cart')}
                  >
                    <ShoppingCartIcon className="h-6 w-6" />
                    {itemCount > 0 && (
                      <span className="absolute -top-0.5 -right-0.5 min-w-[1.25rem] h-5 px-1 rounded-full bg-primary-600 text-white text-[11px] font-semibold flex items-center justify-center">
                        {itemCount > 99 ? '99+' : itemCount}
                      </span>
                    )}
                  </Link>
                )}
                <Link
                  to={dashboardPath}
                  className="px-4 py-2 text-sm font-medium text-white bg-primary-600 rounded-md hover:bg-primary-700"
                >
                  {t('nav.dashboard')}
                </Link>
              </>
            ) : (
              <>
                <Link
                  to="/login"
                  className="text-sm text-primary-600 hover:text-primary-700"
                >
                  {t('nav.login')}
                </Link>
                <Link
                  to="/register"
                  className="px-4 py-2 text-sm font-medium text-white bg-primary-600 rounded-md hover:bg-primary-700"
                >
                  {t('nav.register')}
                </Link>
              </>
            )}
            <LanguageSwitcher />
          </div>
        </div>
      </div>

      {/* Page content */}
      <main className="flex-1">
        <div className="py-6">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <Outlet />
          </div>
        </div>
      </main>
    </div>
  )
}

export default PublicLayout
